export default "__VITE_ASSET__DfHJfXaq__"